// extracted by mini-css-extract-plugin
export default {"typing_text":"styles_typing_text__3-j+p","typing":"styles_typing__26zEM","cursor-blink":"styles_cursor-blink__SkEKg"};